import useNewChat from '../../hooks/chat-room/useNewChat';

export default function CollapsedSidebarNewChat() {
  const { handleNewChatBtnClick } = useNewChat();

  return (
    <div className="w-layout-hflex new-chat-btn-sidebar-container">
      <button
        prop-events-names="onClick"
        prop-events-value-onclick="handleNewChatBtnClick"
        title="New Chat"
        onClick={handleNewChatBtnClick}
        className="-layout-hflex new-chat-btn-block all-whiten-in-dark-mode greyish-bg-in-darkmode new-chat-btn-block-small-block light-grey-bg-dark-mode"
      >
        <img
          src="/images/plus.svg"
          loading="lazy"
          alt="Create New Chat By Clicking on New Chat Button"
          className="image-32"
        />
        <span className="sr-only">New Chat</span>
      </button>
    </div>
  );
}
